import { combineReducers } from '@reduxjs/toolkit';

import { EntriesStateType } from '../constants';
import { ActiveStakesState } from '../types/activeStakes';
import { CashOutStakesState } from '../types/cashOutStakes';
import { EntriesState } from '../types/entries';
import { InformationTileState } from '../types/informationTile';
import { SidebarPreferencesState } from '../types/sidebarPreferences';
import activeStakes from './activeStakes';
import cashOutStakes from './cashOutStakes';
import historyStakes from './historyStakes';
import informationTile from './informationTile';
import sidebarPreferences from './sidebarPreferences';

// ---

export type MyStakesState = {
  [EntriesStateType.ACTIVE]: ActiveStakesState;
  [EntriesStateType.HISTORY]: EntriesState;
  informationTile: InformationTileState;
  sidebarPreferences: SidebarPreferencesState;
  cashOutStakes: CashOutStakesState;
};

export default combineReducers({
  [EntriesStateType.ACTIVE]: activeStakes,
  [EntriesStateType.HISTORY]: historyStakes,
  informationTile,
  sidebarPreferences,
  cashOutStakes,
});
